import { render, staticRenderFns } from "./ExamPage.vue?vue&type=template&id=e6571662&scoped=true"
import script from "./ExamPage.vue?vue&type=script&lang=js"
export * from "./ExamPage.vue?vue&type=script&lang=js"
import style0 from "./ExamPage.vue?vue&type=style&index=0&id=e6571662&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6571662",
  null
  
)

export default component.exports